import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const Disciplines = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 px-6 bg-[#F6F4F1]">
      <div className="max-w-7xl mx-auto">
        {/* Service Categories */}
        <div className="grid md:grid-cols-4 gap-12 mb-20">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-light text-[#2C2C2C] lowercase mb-4">
              {t('home.disciplines.residential')}
            </p>
            <p className="text-base font-light text-[#5A5A5A] leading-relaxed">
              {t('home.disciplines.residentialDesc')}
            </p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-light text-[#2C2C2C] lowercase mb-4">
              {t('home.disciplines.hospitality')}
            </p>
            <p className="text-base font-light text-[#5A5A5A] leading-relaxed">
              {t('home.disciplines.hospitalityDesc')}
            </p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-light text-[#2C2C2C] lowercase mb-4">
              {t('home.disciplines.commercial')}
            </p>
            <p className="text-base font-light text-[#5A5A5A] leading-relaxed">
              {t('home.disciplines.commercialDesc')}
            </p>
          </div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-light text-[#2C2C2C] lowercase mb-4">
              {t('home.disciplines.identity')}
            </p>
            <p className="text-base font-light text-[#5A5A5A] leading-relaxed">
              {t('home.disciplines.identityDesc')}
            </p>
          </div>
        </div>

        {/* What a Project Includes Section */}
        <div className="max-w-4xl mx-auto text-center border-t border-[#E5E5E5] pt-16">
          <h3 className="text-2xl md:text-3xl font-light text-[#2C2C2C] mb-6">
            {t('home.projectIncludes.title')}
          </h3>
          <p className="text-lg font-light text-[#2C2C2C] leading-relaxed">
            {t('home.projectIncludes.intro1')}
          </p>
          <p className="text-lg font-light text-[#2C2C2C] mb-6 leading-relaxed">
            {t('home.projectIncludes.intro2')}
          </p>
          <p className="text-base font-light text-[#5A5A5A] mb-6 leading-relaxed">
            {t('home.projectIncludes.services')}
          </p>
          <p className="text-lg font-light text-[#2C2C2C]">
            {t('home.projectIncludes.closing')}
          </p>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <Link
            to="/contact"
            className="inline-block text-lg font-light text-[#2C1810] lowercase tracking-wide hover:opacity-70 transition-opacity duration-300 border-b border-[#2C1810]"
          >
            {t('home.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Disciplines;
